import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "d-flex flex-row mt-20 ms-20" }
const _hoisted_3 = { class: "card bg-primary text-white p-15 mb-25 col-md me-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, "TOTAL DES DETTES", -1)
const _hoisted_5 = { class: "fw-bold fs-30" }
const _hoisted_6 = { class: "card bg-primary text-white p-15 mb-25 col-md" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, "TOTAL DES DETTES DE CE MOIS", -1)
const _hoisted_8 = { class: "fw-bold fs-30" }
const _hoisted_9 = { class: "card bg-primary text-white p-15 mb-25 col-md mx-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, "TOTAL DES DETTES DE CE JOUR", -1)
const _hoisted_11 = { class: "fw-bold fs-30" }
const _hoisted_12 = { class: "card-head box-shadow bg-white d-md-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "bg-transparent text-primary transition p-0 border-0"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-search-interface-symbol" })
], -1)
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"d-sm-flex align-items-center\"><a class=\"default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none\" href=\"#\" data-bs-toggle=\"modal\" data-bs-target=\"#AddElementModal\"><i class=\"flaticon-plus position-relative ms-5 fs-12\"></i> Ajouter un reglement </a><button class=\"default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mt-10 mt-md-0\" type=\"button\"> Export <i class=\"flaticon-file-1 position-relative ms-5 top-2 fs-15\"></i></button></div>", 1)
const _hoisted_15 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_16 = { class: "table-responsive" }
const _hoisted_17 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
    }, " # "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
    }, " Date "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
    }, " Client "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Montant regler "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Reste à payer "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Vente "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
    }, " Actions ")
  ])
], -1)
const _hoisted_19 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_21 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_22 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_23 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_24 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_25 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_26 = { class: "dropdown" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", {
  class: "badge text-white bg-primary fs-15 dropdown-toggle",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createTextVNode(" Actions "),
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
], -1)
const _hoisted_28 = { class: "dropdown-menu" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_31 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!
  const _component_AddReglementModal = _resolveComponent("AddReglementModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.formatMontant(_ctx.totalDette)), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.formatMontant(_ctx.totalDetteDuMois)), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.formatMontant(_ctx.totalDetteDuJour)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("form", {
          class: "search-box position-relative",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
            onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
            class: "form-control shadow-none text-black rounded-0 border-0",
            placeholder: "Rechercher un encaissement"
          }, null, 544), [
            [_vModelText, _ctx.searchTerm]
          ]),
          _hoisted_13
        ], 32),
        _hoisted_14
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("table", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.elements, (reg, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_19, _toDisplayString((reg) ? reg.id : ""), 1),
                  _createElementVNode("td", _hoisted_20, _toDisplayString((reg) ? _ctx.format_Date(reg.dateReglement) : ""), 1),
                  _createElementVNode("td", _hoisted_21, _toDisplayString((reg.vente) ?
                  " [ "+reg.vente.client.code+" ] "+reg.vente.client.nom+" "+reg.vente.client.prenoms
                   : ""), 1),
                  _createElementVNode("td", _hoisted_22, _toDisplayString((reg.montant) ? reg.montant : ""), 1),
                  _createElementVNode("td", _hoisted_23, _toDisplayString((reg.restAPayer) ? reg.restAPayer : ""), 1),
                  _createElementVNode("td", _hoisted_24, _toDisplayString((reg.vente.id) ? reg.vente.id : ""), 1),
                  _createElementVNode("td", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _hoisted_27,
                      _createElementVNode("ul", _hoisted_28, [
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item d-flex align-items-center",
                            href: "javascript:void(0);",
                            onClick: ($event: any) => (_ctx.suppression(reg.id,_ctx.elements,'reglement','ce reglement'))
                          }, [
                            _hoisted_30,
                            _createTextVNode(" Annuler ")
                          ], 8, _hoisted_29)
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createVNode(_component_PaginationComponent, {
            page: _ctx.page,
            totalPages: _ctx.totalPages,
            totalElements: _ctx.totalElements,
            limit: _ctx.limit,
            onPaginate: _ctx.handlePaginate
          }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
        ])
      ])
    ]),
    _createVNode(_component_AddReglementModal, {
      item: _ctx.selectedItem,
      onClose: _ctx.recharger
    }, null, 8, ["item", "onClose"])
  ], 64))
}